import { IDisplayableImageEncoder } from 'app/interfaces/IDisplayableImageEncoder';
import React from 'react';

const IDisplayableImageEncoderContext = React.createContext<IDisplayableImageEncoder>(undefined);

export default IDisplayableImageEncoderContext;
